import { useState, useEffect, useRef } from 'react';

interface UseLazyImageOptions {
	threshold?: number;
	rootMargin?: string;
	triggerOnce?: boolean;
}

export const useLazyImage = (options: UseLazyImageOptions = {}) => {
	const { threshold = 0.1, rootMargin = '50px', triggerOnce = true } = options;
	const [isInView, setIsInView] = useState(false);
	const [hasTriggered, setHasTriggered] = useState(false);
	const ref = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const element = ref.current;
		if (!element) return;

		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) {
					setIsInView(true);
					if (triggerOnce) {
						setHasTriggered(true);
					}
				} else if (!triggerOnce) {
					setIsInView(false);
				}
			},
			{
				threshold,
				rootMargin,
			},
		);

		observer.observe(element);

		return () => {
			observer.unobserve(element);
		};
	}, [threshold, rootMargin, triggerOnce]);

	return { ref, isInView: isInView || hasTriggered };
};
